'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var GlobalSvg = /*#__PURE__*/function () {
  function GlobalSvg() {
    (0, _classCallCheck2["default"])(this, GlobalSvg);
    (0, _defineProperty2["default"])(this, "DONE", 0);
    (0, _defineProperty2["default"])(this, "_inited", false);
    (0, _defineProperty2["default"])(this, "REMOVE", 1);
    (0, _defineProperty2["default"])(this, "RETURN", 2);
    (0, _defineProperty2["default"])(this, "scale", 1);
  }
  return (0, _createClass2["default"])(GlobalSvg, [{
    key: "createDom",
    value: function createDom() {
      if (this.inited) {
        return;
      }

      //document attached element not removed by angular
      $('#globalSvgSurface').remove();
      $('#globalSvg').remove();
      var body = $('body');
      this._container = Entry.Dom('div', {
        classes: ['globalSvgSurface', 'entryRemove'],
        id: 'globalSvgSurface',
        parent: body
      });
      this.svgDom = Entry.Dom($('<svg id="globalSvg" width="1" height="1"' + 'version="1.1" xmlns="http://www.w3.org/2000/svg"></svg>'), {
        parent: this._container
      });
      this.svg = Entry.SVG('globalSvg');
      this.svgPoint = this.svg.createSVGPoint();
      this.left = 0;
      this.top = 0;
      this._inited = true;
    }
  }, {
    key: "setView",
    value: function setView(view, mode) {
      if (view == this._view) {
        return;
      }
      var data = view.block || view;
      if (data.isReadOnly() || !view.movable) {
        return;
      }
      this._view = view;
      this._mode = mode;
      this.isFromBlockMenu = view.dragInstance && view.dragInstance.isNew;
      view.set({
        visible: false
      });
      this.draw();
      this.show();
      this.align();
      this.position();
      return true;
    }
  }, {
    key: "getView",
    value: function getView() {
      return this._view;
    }
  }, {
    key: "canAddStorageBlock",
    get: function get() {
      var _ref = this._view || {},
        _ref$block = _ref.block,
        block = _ref$block === void 0 ? {} : _ref$block;
      var copyable = block.copyable;
      return !this.isFromBlockMenu && copyable;
    }
  }, {
    key: "setComment",
    value: function setComment(view, mode) {
      if (view == this._view || view.readOnly || !view.movable) {
        return;
      }
      view._path.attr({
        id: "".concat(view.id, "C"),
        stroke: 'red'
      });
      view._titlePath.attr({
        id: "".concat(view.id, "T")
      });
      view._textPath.attr({
        href: "#".concat(view.id, "C")
      });
      view._titleTextPath.attr({
        href: "#".concat(view.id, "T")
      });
      this._view = view;
      this._mode = mode;
      this.originalX = view.x;
      this.originalY = view.y;
      this.draw();
      this.show();
      this.align();
      this.commentPosition();
    }
  }, {
    key: "draw",
    value: function draw() {
      var blockView = this._view;
      if (this._svg) {
        this.remove();
      }
      var isVimMode = this._mode == Entry.Workspace.MODE_VIMBOARD;
      var bBox = blockView.svgGroup.getBBox();
      var width = bBox.width,
        height = bBox.height;
      this.svgDom.attr({
        width: "".concat(Math.round(bBox.width + 4), "px"),
        height: "".concat(Math.round(bBox.height + 4), "px")
      });
      this.xScaleDiff = width * (this.scale - 1) / (this.scale * 2);
      this.yscaleDiff = height * (this.scale - 1) / (this.scale * 2);
      this.svgGroup = Entry.SVG.createElement(blockView.svgGroup.cloneNode(true), {
        opacity: 1
      });
      this.svg.appendChild(this.svgGroup);
      if (blockView.svgCommentGroup) {
        this.svgCommentGroup = Entry.SVG.createElement(blockView.svgCommentGroup.cloneNode(true), {
          opacity: 1
        });
        this.svg.appendChild(this.svgCommentGroup);
      }
      //TODO selectAll function replace
      if (isVimMode) {
        var $svg = $(this.svgGroup);
        var $svgComment = $(this.svgCommentGroup);
        $svg.find('g').css({
          filter: 'none'
        });
        $svgComment.find('g').css({
          filter: 'none'
        });
        $svg.find('path, rect, polygon').velocity({
          opacity: 0
        }, {
          duration: 500
        });
        $svgComment.find('path, rect, polygon').velocity({
          opacity: 0
        }, {
          duration: 500
        });
        $svg.find('text').velocity({
          fill: '#000000'
        }, {
          duration: 530
        });
        $svgComment.find('text').velocity({
          fill: '#000000'
        }, {
          duration: 530
        });
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      if (!this.svgGroup) {
        return;
      }
      this.svgGroup.remove();
      delete this.svgGroup;
      if (this.svgCommentGroup) {
        this.svgCommentGroup.remove();
        delete this.svgCommentGroup;
      }
      delete this._view;
      delete this._offsetX;
      delete this._offsetY;
      delete this._startX;
      delete this._startY;
      this.hide();
    }
  }, {
    key: "align",
    value: function align() {
      var offsetX = 0;
      var offsetY = 0;
      if (this._view.getSkeleton) {
        offsetX = this._view.getSkeleton().box(this._view).offsetX || 0;
        offsetY = this._view.getSkeleton().box(this._view).offsetY || 0;
      }
      offsetX *= -1;
      offsetX += 1;
      offsetY *= -1;
      offsetY += 1;
      this._offsetX = offsetX;
      this._offsetY = offsetY;
      var transform = "translate(".concat(offsetX, ", ").concat(offsetY, ")");
      this.svgGroup.attr({
        transform: transform
      });
      if (this.svgCommentGroup) {
        this.svgCommentGroup.attr({
          transform: transform
        });
      }
    }
  }, {
    key: "show",
    value: function show() {
      this.isShow = true;
      this._container.removeClass('entryRemove');
    }
  }, {
    key: "hide",
    value: function hide() {
      this.isShow = false;
      this._container.addClass('entryRemove');
    }
  }, {
    key: "position",
    value: function position(value) {
      var blockView = this._view;
      if (!blockView) {
        return;
      }
      var pos = blockView.getAbsoluteCoordinate();
      var offset = blockView.getBoard().offset();
      if (value) {
        this.left += value.left / this.scale;
        this.top += value.top / this.scale;
      } else {
        this.left = pos.scaleX + (offset.left / this.scale - this._offsetX);
        this.top = pos.scaleY + (offset.top / this.scale - this._offsetY);
      }
      this._applyDomPos(this.left, this.top);
    }
  }, {
    key: "commentPosition",
    value: function commentPosition() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$startX = _ref2.startX,
        startX = _ref2$startX === void 0 ? 0 : _ref2$startX,
        _ref2$startY = _ref2.startY,
        startY = _ref2$startY === void 0 ? 0 : _ref2$startY;
      var view = this._view;
      if (!view) {
        return;
      }
      var pos = view.getAbsoluteCoordinate();
      var offset = view.board.offset();
      this.left = pos.scaleX + (offset.left / this.scale - this._offsetX) - this.originalX;
      this.top = pos.scaleY + (offset.top / this.scale - this._offsetY) - this.originalY;
      var _this$svgGroup$getEle = this.svgGroup.getElementsByTagName('line'),
        _this$svgGroup$getEle2 = (0, _slicedToArray2["default"])(_this$svgGroup$getEle, 1),
        line = _this$svgGroup$getEle2[0];
      if (line) {
        line.setAttribute('x1', startX / this.scale - this.left + view.parentWidth);
        line.setAttribute('y1', startY / this.scale - this.top + view.parentHeight / 2);
      }
      this._applyDomPos(this.left, this.top);
    }
  }, {
    key: "adjust",
    value: function adjust(adjustX, adjustY) {
      var left = this.left + (adjustX || 0);
      var top = this.top + (adjustY || 0);
      if (left === this.left && top === this.top) {
        return;
      }
      this.left = left;
      this.top = top;
      this._applyDomPos(this.left, this.top);
    }
  }, {
    key: "_applyDomPos",
    value: function _applyDomPos(left, top) {
      this.svgDom.css({
        transform: "scale(".concat(this.scale, ") translate3d(").concat(left + this.xScaleDiff, "px,").concat(top + this.yscaleDiff, "px, 0px)")
      });
    }
  }, {
    key: "terminateDrag",
    value: function terminateDrag(blockView) {
      var mousePos = Entry.mouseCoordinate;
      var board = blockView.getBoard();
      var blockMenu = board.workspace.blockMenu;
      var bLeft = blockMenu.offset().left;
      var bTop = blockMenu.offset().top;
      var bWidth = blockMenu.visible ? blockMenu.blockMenuContainer.width() : 0;
      var backPackWidth = 0;
      var windowWidth = window.innerWidth;
      var backPackMode = Entry.playground.backPack.isShow;
      if (backPackMode) {
        backPackWidth = 135;
      }
      if (mousePos.y > board.offset().top - 20 && mousePos.x > bLeft + bWidth && mousePos.x < windowWidth - backPackWidth) {
        return this.DONE;
      } else if (mousePos.y > bTop && mousePos.x > bLeft && mousePos.x <= bLeft + bWidth && blockMenu.visible) {
        if (blockView.block && !blockView.block.isDeletable()) {
          return this.RETURN;
        } else {
          return this.REMOVE;
        }
      } else {
        return this.RETURN;
      }
    }
  }, {
    key: "addControl",
    value: function addControl() {
      this.onMouseDown.apply(this, arguments);
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      this._startY = e.pageY;
      var that = this;
      e.stopPropagation();
      e.preventDefault();
      if (e.which == 2) {
        console.log('mouse wheel click disabled');
        return;
      }
      var $doc = $(document);
      $doc.bind('mousemove.block', onMouseMove);
      $doc.bind('mouseup.block', onMouseUp);
      $doc.bind('touchmove.block', onMouseMove);
      $doc.bind('touchend.block', onMouseUp);
      this._startX = e.pageX;
      this._startY = e.pageY;
      function onMouseMove(e) {
        var newX = e.pageX;
        var newY = e.pageY;
        var dX = newX - that._startX;
        var dY = newY - that._startY;
        var newLeft = that.left + dX;
        var newTop = that.top + dY;
        that._applyDomPos(newLeft, newTop);
        that._startX = newX;
        that._startY = newY;
        that.left = newLeft;
        that.top = newTop;
      }
      function onMouseUp(e) {
        if (e.which == 2) {
          console.log('mouse wheel click disabled');
          return;
        }
        $(document).unbind('.block');
      }
    }
  }, {
    key: "setScale",
    value: function setScale() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.scale = scale;
    }
  }, {
    key: "getRelativePoint",
    value: function getRelativePoint(matrix) {
      return this.svgPoint.matrixTransform(matrix);
    }
  }]);
}();
Entry.GlobalSvg = new GlobalSvg();